import axios from "axios";
import {Constant} from '../helpers/const';
import {getBrowser} from "../helpers/utils";

export default class ApiService {
    defaultOptions = {
        baseURL: Constant.API_BASE,
        timeout: 200000, //200 secondes
        headers: {
            'Content-Type': 'application/json',
            'currentSession': JSON.stringify(getBrowser())
        },
    };

    getInstance(apikey) {
        // Create instance
        let instance = axios.create(this.defaultOptions);
        instance.defaults.headers['X-API-KEY'] = apikey;
        return instance;
    }

    get(endPoint, apikey, params) {
        return this.getInstance(apikey)
            .get(endPoint, {params: params});
    }

    post(endPoint, apikey, data) {
        return this.getInstance(apikey)
            .post(endPoint, data);
    }

    patch(endPoint, apikey, data) {
        return this.getInstance(apikey)
            .patch(endPoint, data);
    }

    delete(endPoint, apikey) {
        return this.getInstance(apikey)
            .delete(endPoint);
    }

}

